
import { useCallback } from 'react';

interface UseRefreshProps {
  initialPage: number;
  loadPosts: (page: number, replace: boolean, forceRefresh: boolean) => Promise<void>;
  resetPosts: () => void;
  setHasMore: (hasMore: boolean) => void;
  setCurrentPage: (page: number) => void;
  setLoading: (loading: boolean) => void;
}

export const useRefresh = ({
  initialPage,
  loadPosts,
  resetPosts,
  setHasMore,
  setCurrentPage,
  setLoading
}: UseRefreshProps) => {
  const resetPagination = useCallback(() => {
    console.log("Resetting pagination state");
    setCurrentPage(initialPage);
    resetPosts();
    setLoading(true);
    setHasMore(true);
  }, [initialPage, resetPosts, setCurrentPage, setLoading, setHasMore]);

  const refetch = useCallback(async () => {
    console.log('Explicitly refetching posts from beginning');
    
    // First reset pagination state
    resetPagination();
    
    // Clear cache by forcing a refresh
    try {
      console.log('Forcing cache invalidation and fresh data fetch');
      await loadPosts(initialPage, true, true);
    } catch (error) {
      console.error('Error during refetch:', error);
      // Try one more time after a short delay
      setTimeout(async () => {
        try {
          console.log('Retrying fetch after error...');
          await loadPosts(initialPage, true, true);
        } catch (retryError) {
          console.error('Retry fetch also failed:', retryError);
        }
      }, 300);
    }
  }, [initialPage, loadPosts, resetPagination]);

  return {
    resetPagination,
    refetch
  };
};
